import dayjs from "dayjs";
import { CalendarItemMap } from "../Calendar/CalendarItemMap.ts";
import { SlotDayAndHourKey } from "../Calendar/SlotDayAndHourKey.ts";

export const DISPLAY_TZ = "Europe/Rome";

export type BusyUserNormalized = {
  id: string;
  email: string;
  workCategory?: string;
  eventTitle?: string;
};

export type CloserAvailabilityNormalizedSlot = {
  slotStart: string;
  slotEnd: string;
  availableUsers: { id: string; email: string }[];
  busyWorkUsers?: BusyUserNormalized[];
  busyOooUsers?: BusyUserNormalized[];
};

export type CloserAvailabilityHourGroup = {
  slots: CloserAvailabilityNormalizedSlot[];
};

export function createCloserAvailabilityCalendarMap(
  slots: CloserAvailabilityNormalizedSlot[],
): CalendarItemMap<CloserAvailabilityHourGroup> {
  const grouped = new Map<string, CloserAvailabilityNormalizedSlot[]>();

  for (const slot of slots) {
    const key = SlotDayAndHourKey.fromDate(
      dayjs(slot.slotStart).tz(DISPLAY_TZ),
    );
    const mapKey = `${key.dateString}_${key.hourString}`;
    const existing = grouped.get(mapKey);
    if (existing) {
      existing.push(slot);
    } else {
      grouped.set(mapKey, [slot]);
    }
  }

  const map = new CalendarItemMap<CloserAvailabilityHourGroup>();
  const added = new Set<string>();

  for (const slot of slots) {
    const key = SlotDayAndHourKey.fromDate(
      dayjs(slot.slotStart).tz(DISPLAY_TZ),
    );
    const mapKey = `${key.dateString}_${key.hourString}`;
    if (!added.has(mapKey)) {
      const group = grouped.get(mapKey);
      if (group) {
        map.set(key, { slots: group });
        added.add(mapKey);
      }
    }
  }

  return map;
}
